<template>
  <hooper v-bind="$attrs">
    <slide v-for="(item, index) in images" :key="index">
      <img :src="item.src" width="76" height="76">
    </slide>
  </hooper>
</template>
<script>
// eslint-disable-next-line import/no-extraneous-dependencies
import { Hooper, Slide } from 'hooper';
// eslint-disable-next-line import/no-extraneous-dependencies
import 'hooper/dist/hooper.css';

export default {
  name: 'LogoCarousel',

  props: {
    images: {
      type: Array,
      required: true,
    },
  },

  components: {
    Hooper,
    Slide,
  },

  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
.hooper {
  height: auto !important;
}

::v-deep .hooper-slide {
  width: 88px !important;
  height: 88px !important;
  padding: 6px;
  margin: 0 6px;
  opacity: 0.6;
  mix-blend-mode: luminosity;

  img,
  svg {
    filter: grayscale(100%);
  }
}
</style>
